import ComposableArticleCard from './ComposableArticleCard';
import ComposableBrandSlider from './ComposableBrandSlider';
import ComposableFollowedBrandCard from './ComposableFollowedBrandCard';
import ComposableInfoCard from './ComposableInfoCard';
import ComposableMixedContent from './ComposableMixedContent';
import ComposableMixedContentSlider from './ComposableMixedContentSlider';
import ComposableVideoCard from './ComposableVideoCard';
import ComposableVideoPortalCard from './ComposableVideoPortalCard';
import ComposableVideoSliderCard from './ComposableVideoSliderCard';
import CARD_CONTENT_TYPE from './enum/cardListContentTypes';
import CARD_VIEW_TYPE from './enum/cardListViewTypes';
import renderComposableArticlePortalCard from './renderComposableArticlePortalCard';

/**
 * Determines which card is being rendered
 * @param viewType the container of the cards  (e.g. Slider or CardList)
 * @param contentType determines the type of content in the cards (e.g. articles, videos, static page)
 * @returns a card
 */
const getCardComponentByType = (contentType, viewType) => {
  if (
    CARD_CONTENT_TYPE.brand === contentType &&
    viewType === CARD_VIEW_TYPE.slider
  ) {
    return ComposableBrandSlider;
  }

  if (
    CARD_CONTENT_TYPE.media === contentType &&
    viewType === CARD_VIEW_TYPE.default
  ) {
    return ComposableVideoCard;
  }

  if (
    CARD_CONTENT_TYPE.article === contentType &&
    viewType === CARD_VIEW_TYPE.default
  ) {
    return ComposableArticleCard;
  }

  if (
    CARD_CONTENT_TYPE.mixed === contentType &&
    viewType === CARD_VIEW_TYPE.default
  ) {
    return ComposableMixedContent;
  }

  if (
    CARD_CONTENT_TYPE.followedBrand === contentType &&
    viewType === CARD_VIEW_TYPE.default
  ) {
    return ComposableFollowedBrandCard;
  }

  if (
    CARD_CONTENT_TYPE.slide === contentType &&
    viewType === CARD_VIEW_TYPE.slider
  ) {
    return ComposableMixedContentSlider;
  }

  if (
    CARD_CONTENT_TYPE.media === contentType &&
    viewType === CARD_VIEW_TYPE.slider
  ) {
    return ComposableVideoSliderCard;
  }

  if (
    CARD_CONTENT_TYPE.teaser === contentType &&
    viewType === CARD_VIEW_TYPE.info
  ) {
    return ComposableInfoCard;
  }

  if (
    CARD_CONTENT_TYPE.article === contentType &&
    viewType === CARD_VIEW_TYPE.firstItemHighlighted
  ) {
    return renderComposableArticlePortalCard;
  }

  if (
    CARD_CONTENT_TYPE.teaser === contentType &&
    viewType === CARD_VIEW_TYPE.fullWidth
  ) {
    return ComposableVideoPortalCard;
  }

  throw new Error(`type ${contentType} with ${viewType} is not supported yet`);
};

export default getCardComponentByType;
